/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * 
현재 로그인한 사용자의 활동 로그를 조회합니다.

**지원 필터**:
- category: auth, quote, chat, profile 중 선택
- from/to: 날짜 범위 (ISO8601)
- page/limit: 페이지네이션

**정렬**: 최신순 (created_at DESC)
    
 * @summary 내 활동 로그 조회
 */
export const activityLogsControllerGetMyActivityLogsQueryPageDefault = 1;

export const activityLogsControllerGetMyActivityLogsQueryLimitDefault = 20;
export const activityLogsControllerGetMyActivityLogsQueryLimitMax = 100;

export const activityLogsControllerGetMyActivityLogsQuerySortByDefault =
  "created_at";
export const activityLogsControllerGetMyActivityLogsQuerySortOrderDefault =
  "desc";

export const activityLogsControllerGetMyActivityLogsQueryParams = zod
  .object({
    page: zod.coerce
      .number()
      .min(1)
      .default(activityLogsControllerGetMyActivityLogsQueryPageDefault)
      .describe("페이지 번호"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(activityLogsControllerGetMyActivityLogsQueryLimitMax)
      .default(activityLogsControllerGetMyActivityLogsQueryLimitDefault)
      .describe("페이지당 항목 수"),
    sortBy: zod.coerce
      .string()
      .default(activityLogsControllerGetMyActivityLogsQuerySortByDefault)
      .describe("정렬 필드"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(activityLogsControllerGetMyActivityLogsQuerySortOrderDefault)
      .describe("정렬 순서"),
    search: zod.coerce.string().optional().describe("검색어"),
    category: zod
      .enum([
        "auth",
        "quote",
        "chat",
        "profile",
        "payment",
        "contract",
        "security",
        "promotion",
      ])
      .optional()
      .describe("활동 카테고리 필터"),
    from: zod.coerce.string().optional().describe("조회 시작 날짜 (ISO8601)"),
    to: zod.coerce.string().optional().describe("조회 종료 날짜 (ISO8601)"),
  })
  .strict();

export const activityLogsControllerGetMyActivityLogsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("로그 ID"),
              category: zod
                .enum([
                  "auth",
                  "quote",
                  "chat",
                  "profile",
                  "payment",
                  "contract",
                  "security",
                  "promotion",
                ])
                .describe("카테고리"),
              action: zod.string().describe("액션 타입"),
              actionLabel: zod.string().describe("액션 한글 라벨"),
              resourceType: zod.string().optional().describe("리소스 타입"),
              resourceId: zod.string().optional().describe("리소스 ID"),
              metadata: zod.object({}).optional().describe("추가 메타데이터"),
              createdAt: zod.string().describe("생성 시간"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();
